import { FaArrowUp } from "react-icons/fa";

//images
import heroimage from "../../../assets/images/pages/bg-image.jpg";
import heropld from "../../../assets/images/imgplaceholders/homepld.png";

import Feature from "../FeatureStyle";
import ButtonLink from "../links/ButtonLink";
import PreloadImage from "../ImagePreloader/ImagePreloader";

const HeroHome = () => {
  return (
    <section className="min-h-screen pt-32 pb-20 px-6 relative bg-customgreen overflow-hidden flex items-center justify-center">
      {/* Background circles */}
      <div className="absolute top-[-200px] right-[-200px] w-[600px] h-[600px] rounded-full bg-primary-100 opacity-15 z-0"></div>
      <div className="absolute bottom-[-100px] left-[-100px] w-[400px] h-[400px] rounded-full bg-primary-50 opacity-10 z-0"></div>

      <div className="max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="max-w-[600px] lg:max-w-full mx-auto">
            {/* Animated badge */}
            <div className="inline-flex items-center gap-2 bg-customyellow px-4 py-2 rounded-full shadow-md mb-8 ">
              <span className="flex h-2 w-2 relative">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-800 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-800"></span>
              </span>
              <span className="text-sm font-medium text-primary-800">
                Business Solutions
              </span>
            </div>

            <h1 className="text-primary-900 text-4xl md:text-5xl  font-bold leading-tight mb-6">
              Launch Your Business With Confidence
            </h1>
            <p className="text-text-muted text-dark text-lg leading-relaxed mb-8">
              From incorporation to full operation, we provide end-to-end
              solutions to establish your company, handle regulatory compliance,
              and train your team for success.
            </p>

            <div className="mb-12">
              <ButtonLink
                link="/contact-us"
                className="group relative text-[white] ml-2 bg-primary-900 text-md font-medium transition ease-in-out duration-300"
              >
                <span className="absolute inset-0 w-full h-full transition-all duration-300 ease-out transform -translate-x-full bg-primary-700 group-hover:translate-x-0"></span>
                <span className="relative mr-[2.5rem]"> Contact Us</span>
                <div className="absolute right-1 top-1/2 transform -translate-y-1/2 transition-transform duration-300 ease-out group-hover:translate-x-0 bg-white p-3 rounded-full">
                  <FaArrowUp className=" rotate-45 text-primary-900" />
                </div>
              </ButtonLink>
            </div>

            <div className="flex flex-wrap gap-8">
              <Feature title="Incorporation" />
              <Feature title="Compliance" />
              <Feature title="Staff Training" />
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 rounded-2xl bg-primary-50/20 backdrop-blur-sm transform rotate-3 scale-105"></div>
            <PreloadImage
              imgSrc={heroimage}
              imgAlt="Business professionals working"
              imgClassName="relative w-full h-auto rounded-2xl shadow-md object-cover aspect-[4/3]"
              imgMaxHeight={450}
              imgMaxWidth={605}
              placeholderSrc={heropld}
            />
            {/* <img
              src={heroimage}
              alt="Business professionals working"
              className="relative w-full h-auto rounded-2xl shadow-md object-cover aspect-[4/3]"
            /> */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent rounded-2xl"></div>
            <div
              className="absolute bottom-6 right-[-30px] bg-white shadow-lg rounded-xl p-4 flex items-center gap-4 animate-bounce"
              style={{ animationDuration: "3s" }}
            >
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-900">500+</div>
                <div className="text-sm text-text-muted">Companies</div>
              </div>
              <div className="w-px h-10 bg-gray-200"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-900">98%</div>
                <div className="text-sm text-text-muted">Success Rate</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroHome;
